// We need to stop this event from bubbling up in order for the href to be executed on click.
const handleHrefClick = (event)=>{
    event.stopPropagation();
};

export { handleHrefClick };
//# sourceMappingURL=helpers.js.map
